(function AdzukiMultiselect($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['selected-option'],
		props: {
			multiple: {
				type   : Boolean,
				default: false,
			},
			optionsData: {
				type    : Array,
				required: true,
			},
			label: {
				type: String,
			},
			identifier: {
				type   : String,
				default: ''
			},
			buttonOptions: {
				type   : Object,
				default: {
					class: 'btn btn-primary',
					text : 'Select'
				}
			},
			showSelections: {
				type   : Boolean,
				default: true,
			},
			selectionType: {
				type     : String,
				default  : 'list',
				validator: function typeValid(value) {
					return ['list', 'badge'].includes(value);
				}
			},
			liveSearch: {
				type   : Boolean,
				default: false,
			}
		},
		data() {
			return {
				selected    : this.multiple ? [] : null,
				dropdownOpen: false,
				openGroups  : [],
				search      : '',
			};
		},
		computed: {
		},
		methods: {
			toggleDropdown(event) {
				event.stopPropagation();
				this.dropdownOpen = !this.dropdownOpen;
				this.search = '';
			},
			toggleGroup(groupName) {
				const idx = this.openGroups.indexOf(groupName);

				if (idx === -1) {
					this.openGroups.push(groupName);
				} else {

					this.openGroups.splice(idx, 1);
				}
			},
			isGroupOpen(groupName) {
				return this.openGroups.includes(groupName);
			},
			emitSelection() {
				this.$emit('selected-option', {
					identifier: this.identifier,
					selected  : this.selected
				});
			},
			reset() {
				this.selected = this.multiple ? [] : null;
				this.search = '';
				this.emitSelection(); // Emit update if needed so the parent also resets
			},
			getOptionName(optionId) {
				console.log(optionId);
				for (let i = 0; i < this.optionsData.length; i++) {
					const opt = this.optionsData[i];
					if (opt.options) {
						for (let j = 0; j < opt.options.length; j++) {
							const optGroup = opt.options[j];
							if (optGroup.id === optionId) {
								return optGroup.name;
							}
						}
					} else if (opt.id === optionId) {
						return opt.name;
					}
				}
				// Option not found
				return optionId;

			},
			removeSelection(selectionId) {
				if (this.multiple) {
					const idx = this.selected.indexOf(selectionId);
					if (idx !== -1) {
						this.selected.splice(idx, 1);
					}
				} else {
					this.selected = null;
				}
				this.emitSelection();
			},
			handleClickOutside(event) {
				// Check if the click is outside this specific component instance
				if (this.$el && !this.$el.contains(event.target)) {
					this.dropdownOpen = false;
				}
			},
			searchResults(term) {
				return this.search === '' || term.toLowerCase().includes(this.search.toLowerCase());
			}
		},
		template: `
          <label class="form-label" v-html="label"></label>
          <div class="adzuki-multiselect-dropdown position-relative mt-2">
            <button type="button" :class="buttonOptions.class + ' dropdown-toggle w-100'" @click="toggleDropdown">{{ buttonOptions.text }}</button>
			<div v-if="dropdownOpen" class="dropdown-menu show w-100 pt-0" @click.stop>
				<div class="ms-search-container">
					<input v-if="liveSearch" type="text" class="form-control" v-model="search" placeholder="Search">
				</div>
				<div class="overflow-auto list-group list-group-flush ms-options-container" style="max-height: 250px;">
					<template v-for="opt in optionsData">
						<div v-if="opt.options" :key="'group-' + opt.groupName" class="dropdown-optgroup">
							<div class="dropdown-optgroup-header" @click="toggleGroup(opt.groupName)">
								<strong>{{ opt.groupName }}</strong>
								<span class="chevron">{{ isGroupOpen(opt.groupName) ? '▼' : '▶' }}</span>
							</div>
							<div v-show="isGroupOpen(opt.groupName)" class="dropdown-optgroup-options">
								<template v-for="groupOpt in opt.options" :key="'group-opt-' + groupOpt.id">
									<div v-if="searchResults(groupOpt.name)" class="list-group-item">
										<input
											class="form-check-input adzuki-multi-input m-0"
											:type="multiple ? 'checkbox' : 'radio'"
											:name="'adzuki-multiselect-' + groupOpt.id"
											:value="groupOpt.id"
											v-model="selected"
											@change="emitSelection"
										/>
										<span>
											{{ groupOpt.name }}
										</span>
									</div>
								</template>
							</div>
						</div>
						<template v-else>
							<div v-if="searchResults(opt.name)" :key="'opt-' + opt.id" class="list-group-item">
								<span>
									<input
										class="form-check-input adzuki-multi-input m-0"
										:type="multiple ? 'checkbox' : 'radio'"
										:name="'adzuki-multiselect-' + opt.id"
										:value="opt.id"
										v-model="selected"
										@change="emitSelection"
									/>
									{{ opt.name }}
								</span>
							</div>
						</template>
					</template>
				</div>
			</div>
			<div class="section-selections mt-2" v-if="showSelections">
			  <template v-if="this.selectionType === 'badge'">
				<span 
					v-for="section in selected"
					:key="'section-'+section"
					class="badge bg-primary me-1 p-1 pointer"
					@click="removeSelection(section)"
				>
					<i class="fas fa-times text-white"></i>
					{{ getOptionName(section) }}
				</span>
              </template>
			  <template v-else-if="this.selectionType === 'list'">
				<ul 
					v-for="section in selected"
					:key="'section-'+section"
					class="list-group list-group-flush"
				>
				  <li class="list-group-item pointer" @click="removeSelection(section)"><i class="fas fa-times"></i> {{getOptionName(section)}}</li>
				</ul>
			  </template>
			</div>
          </div>
		`,
		mounted() {
			document.addEventListener('click', this.handleClickOutside);
		},
		beforeUnmount() {
			document.removeEventListener('click', this.handleClickOutside);
		},
	};

	Adzuki.VueComponents.AdzukiMultiselect = component;
}(jQuery, window.Adzuki || {}));
